import en from "./en";
import ar from "./ar";
import ku from "./ku";

const content = { en, ar, fr: ku };

export default content;
